﻿$.fn.dxCtrlWizardItem1ResaDate = function custom_dxCtrlWizardItem1ResaDate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizarditem1resadate dx-ctrl");
        this.createInstance(new cdxCtrlWizardItem1ResaDate(this, option));
    }
    return this;
}

window.cdxCtrlWizardItem1ResaDate = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxSearch = null
    function mConstruit() {
        container.empty();

        dxSearch = $("<div style='width:100%;'/>").appendTo(container).dxCtrlHebergementSearch({
            bddCtrl: option.bddCtrl,
            showVacances: false,
            forInternetExterne: true,
            dataReservationEnCours: option.dataForResa.dataReservation,
            onSelectHebergement: function (e) {
                mSelectHebergement(e)
            }
        }).dxCtrlHebergementSearch("instance")
    }

    function mSelectHebergement(e) {
        jaugeDemarrage.mShow()
        if (option.dataForResa.dataReservation.id_reservation == null) {
            option.bddCtrl.getObjet(option.dataForResa.dataReservation).mSave(function () {
                option.bddCtrl.mReloadItem(option.dataForResa.dataReservation, function () {
                    var dataResaArrhes = option.bddCtrl.getObjet("reservation_arrhes").mGetNewData()
                    dataResaArrhes.id_reservation = option.dataForResa.dataReservation.id_reservation
                    dataResaArrhes.mt = 0
                    option.bddCtrl.getObjet(dataResaArrhes).mSave(function () {
                        mCreateResaHeberg()
                    })
                })
            })
        } else {
            mCreateResaHeberg()
        }

        function mCreateResaHeberg() {
            option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mCreateNewReservationHebergement(option.dataForResa.dataReservation.id_reservation, e.idHebergement, e.nb_adulte, e.nb_enfant, e.selectedDates.date_debut, e.selectedDates.date_fin, true, null, null, function (data) {
                hasChoisi = true
                jaugeDemarrage.mHide()
                option.onNext()
            })
        }
    }

    var hasChoisi = false
    this.mIsActivated = function () {
        hasChoisi = false
        mConstruit()
    }

    this.isOkForNext = function (dxScroll) {
        var okForNext = true
        var firstElementScroll = null
        var messageErreur = ""
        dxSearch.dxCalendar.element().css("border-left", "")
        dxSearch.element().find(".btchoisir").each(function (idx, ele) { $(ele).css("border-left", "") })

        if (option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetLstReservationHebergement().length == 0) {
            if (!dxSearch.option("selectedDates") || dxSearch.element().find(".btchoisir").length == 0) {
                //pas de dates
                dxSearch.dxCalendar.element().css("border-left", "3px solid red")
                dxSearch.dxCalendar.element().addClass("jiggle").css("animation-duration", "0.12s");
                window.setTimeout(function () { dxSearch.dxCalendar.element().removeClass("jiggle").css("animation-duration", ""); }, 500)
                firstElementScroll = dxSearch.dxCalendar.element()
                if (!dxSearch.option("selectedDates")) {
                    messageErreur = "Veuillez saisir les dates de votre séjour."
                } else {
                    messageErreur = "Aucun hébergement disponible pour les dates selectionnées."
                }
                okForNext = false
            } else if (!hasChoisi) {
                dxSearch.element().find(".btchoisir").each(function (idx, ele) {
                    if (!firstElementScroll) firstElementScroll = $(ele)
                    $(ele).css("border-left", "3px solid red")
                    $(ele).addClass("jiggle").css("animation-duration", "0.12s");
                    window.setTimeout(function () { $(ele).removeClass("jiggle").css("animation-duration", ""); }, 2000)
                })
                messageErreur = "Veuillez choisir un hébergement."
                okForNext = false
            }
        }


        if (dxScroll && firstElementScroll) {
            window.setTimeout(function () {
                dxScroll.smoothScrollToElement(firstElementScroll, 600, function () {
                })
            }, 10)
        }

        if (!okForNext) mNotify(messageErreur, "warning", 6000)

        return okForNext
    }

    this.mGetClassIconeForLstItem = function () {
        return "fas fa-calendar-days"
    }
    this.hasHeight100Percent = function () { return true }
    this.title = function () { return "Choisir vos dates" }
    this.mGetProprieteImage = function () {
        var urlFond = ""
        var lstImage = JSON.parse(option.bddCtrl.paraAppli.mGetPara("hebergement_resa_internet_list_image_arriere_plan"))
        if (lstImage.length > 0) {
            var idxImage = Math.floor(Math.random() * lstImage.length)
            var urlFond = lstImage[idxImage]
        } else {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            var urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
        }
        return {
            url: urlFond,
            position: (parametre.isPhone ? "Gauche" : "Droite")
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            "0/reservation"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        //locationPathname=/nom_base/id_page/reservation
        return locationPathname.split("/")[2]
    }


    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}